import { BaseWizardProps } from './Types'
import { Wizard } from './Wizard/Wizard'
import { FormSchema } from './Wizard/Form/Types'
import { object } from 'yup'
import { filename } from './schemas/shared/filename'
import { project } from './schemas/shared/project'
import { Form } from 'components/Wizards/Form/Form'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { WizardProvider } from './Wizard/WizardContext'

export const BaseWizard = ({
  articleId,
  bodyClassName,
  initialValues = {},
  initialFormStatus,
  stepperVariant,
  schema,
  onSubmit,
}: BaseWizardProps) => {
  const isCreatingNewFile = !articleId
  if (isCreatingNewFile)
    schema = schema.concat(object({ filename, project })) as FormSchema<ChannelType | GenerationType>

  const {
    meta: { title, steps, icon, previewUrl, type },
  } = schema.describe()

  return (
    <WizardProvider schema={schema}>
      <Wizard.Root bodyClassName={bodyClassName} aria-labelledby="wizard-header" type={type}>
        <ResponsiveDesign.Desktop>
          <Wizard.Header
            previewUrl={previewUrl}
            stepperVariant={stepperVariant}
            steps={steps}
            title={title}
            icon={icon}
          />
        </ResponsiveDesign.Desktop>
        <ResponsiveDesign.Mobile>
          <Wizard.MobileHeader stepperVariant={stepperVariant} steps={steps} title={title} icon={icon} />
        </ResponsiveDesign.Mobile>
        <Wizard.Form
          schema={schema}
          onSubmit={onSubmit}
          initialFormStatus={initialFormStatus}
          initialValues={schema.cast({ ...schema.getDefault(), ...initialValues }, { assert: false })}
        >
          <Form.SubmitButton>Generate</Form.SubmitButton>
        </Wizard.Form>
      </Wizard.Root>
    </WizardProvider>
  )
}
